import React, { useEffect, useState } from "react";
import { Form, Input, notification } from "antd";
import StandardModal from "../../../../ui/StandardModal/StandardModal";
import { httpService } from "../../../../base/services/httpService.service";
import { notifyPlanLimitRefusal } from "../../../../components/Billing/planLimits";

import "./workspaceFormModal.scss";

function WorkspaceFormModal({ open, workspace, onCancel, onSaved }) {
   const [form] = Form.useForm();
   const [isSaving, setIsSaving] = useState(false);
   const isEdit = Boolean(workspace);

   useEffect(() => {
      if (!open) return;
      form.setFieldsValue({
         name: workspace?.name ?? "",
         description: workspace?.description ?? ""
      });
   }, [open, workspace, form]);

   const closeModal = () => {
      form.resetFields();
      onCancel();
   };

   const onFinish = async (values) => {
      const name = values.name.trim();
      const description = values.description?.trim() ?? "";

      setIsSaving(true);
      try {
         const payload = isEdit ? { id: workspace.id, name, description } : { name, description };

         await httpService.post(isEdit ? "/Workspaces/edit" : "/Workspaces/add", payload);

         notification.success({
            message: "Success",
            description: isEdit
               ? "Workspace updated successfully."
               : "Workspace added successfully."
         });

         form.resetFields();
         onSaved({ ...workspace, ...payload });
      } catch (error) {
         if (notifyPlanLimitRefusal(error)) return;
         notification.error({
            message: "Error",
            description: `Something went wrong while ${
               isEdit ? "updating" : "adding"
            } this workspace. Please try again later.`
         });
      } finally {
         setIsSaving(false);
      }
   };

   return (
      <StandardModal
         open={open}
         onCancel={closeModal}
         title={isEdit ? "Edit workspace" : "Add workspace"}
         className="workspace-form-modal"
         width={600}
         maskClosable={!isSaving}
         primaryText={isEdit ? "Save changes" : "Add workspace"}
         onPrimary={() => form.submit()}
         primaryLoading={isSaving}
         destroyOnClose
      >
         <Form form={form} layout="vertical" onFinish={onFinish} requiredMark={false}>
            <Form.Item
               name="name"
               label="Workspace name"
               rules={[
                  {
                     required: true,
                     whitespace: true,
                     message: "Workspace name is required."
                  }
               ]}
            >
               <Input placeholder="Enter name" maxLength={100} disabled={isSaving} />
            </Form.Item>

            <Form.Item
               name="description"
               label={
                  <>
                     Description <span className="workspace-form-modal__optional">(optional)</span>
                  </>
               }
            >
               <Input.TextArea
                  placeholder="Enter description"
                  autoSize={{ minRows: 2, maxRows: 5 }}
                  maxLength={500}
                  disabled={isSaving}
               />
            </Form.Item>
         </Form>
      </StandardModal>
   );
}

export default WorkspaceFormModal;
